module.exports = __webpack_public_path__ + "static/img/qlzq.351c62c2.png";